// extracted by mini-css-extract-plugin
module.exports = {"idecoLogo":"AuthWrapper_idecoLogo__23ifH"};